import {DesignSystem, DesignSystemBreakpoints} from "../../../engine/_interfaces/designSystem";

const params: DesignSystemBreakpoints = {
  'tablet': 640,
  'desktop': 960,
  'desktop-large': 1280,
};

const designSystem: DesignSystem = {
  _NAME: 'Breakpoints',
  params,
};

export default designSystem;
